import React, { Component } from "react";
import { observer } from "mobx-react";

import { Icon } from "@formant/ui/component/common/Icon";

import { appStore, authStore, routerStore } from "../../stores";
import { Button } from "../common/Button";
import { Escape } from "../common/Escape";
import { Ducalis } from "../Ducalis";
import { Account } from "./Account";
import { ChannelList } from "./ChannelList";
import Intercom from "./Intercom";
import { ManageMenu } from "./ManageMenu";
import styles from "./SidebarContent.scss";
import { SidebarTabs } from "./SidebarTabs";
import TeleopList from "./TeleopList";

export interface ISidebarContent {
    onClose: () => void;
}

@observer
export class SidebarContent extends Component<ISidebarContent> {
    public render() {
        const { onJump } = this;
        const { onClose } = this.props;

        const hideDucalis = false;
        const hideIntercom = false;

        const isKiosk = authStore.hasAccess("kiosk");

        const sidebarTabs = [
            ...[
                {
                    enabled: authStore.featureEnabled("observability"),
                    name: "Observe",
                    content: <ChannelList onClose={onClose} />,
                },
                ...(isKiosk
                    ? []
                    : [
                          {
                              enabled: authStore.hasAccess(
                                  "teleop",
                                  "operator",
                              ),
                              name: "Operate",
                              content: <TeleopList onClose={onClose} />,
                          },
                      ]),
            ],
        ];
        return (
            <div className={styles["sidebar-content"]}>
                <Escape onEsc={onClose} />
                <div className={styles.header}>
                    <Button
                        data-testid="logo-button"
                        className={styles.logo}
                        onClicked={this.onHome}
                    >
                        <div>
                            <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <polygon
                                    fill="var(--color-text-primary)"
                                    points="0,31.2 8.9,10 17.9,31.2 "
                                />
                                <path
                                    fill="var(--color-text-primary)"
                                    d="M16.4,15.9c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4
        C18.4,20.3,16.4,18.3,16.4,15.9"
                                />
                                <polygon
                                    fill="var(--color-text-primary)"
                                    points="8.9,7.8 31.3,7.8 31.3,0.9 8.9,0.9 "
                                />
                            </svg>
                        </div>
                    </Button>
                    {!hideDucalis && <Ducalis />}
                    {!hideIntercom && <Intercom />}
                </div>
                {!isKiosk && (
                    <Button
                        className={styles.jump}
                        onClicked={onJump}
                        data-testid="jump-to-searchbar"
                    >
                        <Icon name="jump" className={styles.icon} />
                        Jump to...
                        <Icon name="shift" className={styles["hot-key"]} />J
                    </Button>
                )}
                <SidebarTabs tabs={sidebarTabs} onClose={onClose} />

                {!isKiosk && <ManageMenu onClose={onClose} />}
                <Account onClose={onClose} />
            </div>
        );
    }

    private onHome = async () => {
        this.props.onClose();
        const { navigate, routeTo } = routerStore;
        await navigate(routeTo.home());
    };

    private onJump = () => {
        appStore.jump = true;
    };
}
